import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './ThemeToggle.css';

/**
 * "Dark mode" row for the account dropdown menu. Renders like a normal
 * `.dropdown-item` (icon + label) with a switch on the right reflecting
 * the current theme. Tapping the row toggles light/dark.
 */
const ThemeMenuToggle: React.FC<{ onToggle?: (next: 'light' | 'dark') => void }> = ({ onToggle }) => {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  return (
    <button
      className="dropdown-item theme-menu-item"
      role="switch"
      aria-checked={isDark}
      onClick={() => {
        toggle();
        onToggle?.(isDark ? 'light' : 'dark');
      }}
    >
      {isDark ? (
        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
          <path d="M6 1a6 6 0 108 8 5 5 0 01-8-8z" fill="currentColor" />
        </svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
          <circle cx="8" cy="8" r="3.2" fill="currentColor" />
          <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
            <path d="M8 1v1.6M8 13.4V15M1 8h1.6M13.4 8H15M3 3l1.1 1.1M11.9 11.9L13 13M13 3l-1.1 1.1M4.1 11.9L3 13" />
          </g>
        </svg>
      )}
      <span className="theme-menu-label">Dark mode</span>
      <span className={`theme-switch${isDark ? ' on' : ''}`} aria-hidden="true">
        <span className="theme-switch-knob" />
      </span>
    </button>
  );
};

export default ThemeMenuToggle;
